import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Glyphicon, MenuItem, Navbar, Nav, NavDropdown, Modal, Button, Form, FormGroup, ControlLabel, FormControl, Well } from 'react-bootstrap';
import * as moment from 'moment';
import Moment from 'react-moment';

const POPUP_DELAY = 25000;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.submitFeedback = this.submitFeedback.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  submitFeedback = (e) => {
    e.preventDefault();

    const feedback = {
      name: this.name.value,
      email: this.email.value,
      content: this.content.value,
    }

    const API_ENDPOINT = 'https://financial-canvas-studio.firebaseapp.com/sendFeedbackEmail';

    const xhr = new XMLHttpRequest();
    xhr.open('POST', API_ENDPOINT, true);
    xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
    xhr.send(JSON.stringify(feedback));

    setTimeout(this.close, 10);
  }

  componentWillMount() {
    if (localStorage.getItem('studio:popState') !== 'shown' && this.props.enablePopup) {
      setTimeout(() => this.open(), POPUP_DELAY);
      localStorage.setItem('studio:popState', 'shown');
    }
  }

  render() {
    const publicFeedback = (
      <Modal show={this.state.showModal} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Get in touch</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Well>
            <p>Hi, this is Eddy from the Financial Canvas team.</p>
            <p>If you would like to see this dashboard for <strong>your</strong> analytics please enter your details below and we'll get back to you.</p>
          </Well>
          <Form onSubmit={this.submitFeedback}>
            <FormGroup controlId="formControlsText">
              <ControlLabel>Name</ControlLabel>
              <FormControl
                type="text"
                placeholder="Enter your name"
                inputRef={ref => { this.name = ref; }}
              />
            </FormGroup>
            <FormGroup controlId="formControlsEmail">
              <ControlLabel>Email</ControlLabel>
              <FormControl
                type="email"
                placeholder="Enter your email address"
                inputRef={ref => { this.email = ref; }}
              />
            </FormGroup>
            <FormGroup controlId="formControlsTextarea">
              <ControlLabel>Company</ControlLabel>
              <FormControl
                type="text"
                placeholder="Enter your company"
                inputRef={ref => { this.content = ref; }}
              />
            </FormGroup>
            <Button bsStyle="primary" type="submit">
              Submit
       </Button>
          </Form>
        </Modal.Body>
      </Modal>
    );

    const privateFeedback = (
      <Modal show={this.state.showModal} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.submitFeedback}>
            <FormGroup controlId="formControlsText">
              <ControlLabel>Name</ControlLabel>
              <FormControl
                type="text"
                placeholder="Enter your name"
                inputRef={ref => { this.name = ref; }}
              />
            </FormGroup>
            <FormGroup controlId="formControlsEmail">
              <ControlLabel>Email</ControlLabel>
              <FormControl
                type="email"
                placeholder="Enter your email address"
                inputRef={ref => { this.email = ref; }}
              />
            </FormGroup>
            <FormGroup controlId="formControlsTextarea">
              <ControlLabel>Let us know how we're doing</ControlLabel>
              <FormControl
                componentClass="textarea"
                placeholder="Enter your feedback here..."
                inputRef={ref => { this.content = ref; }}
              />
            </FormGroup>
            <Button bsStyle="primary" type="submit">
              Submit
         </Button>
          </Form>
        </Modal.Body>
      </Modal>
    );

    return (
      <div>
        <Navbar inverse collapseOnSelect staticTop style={{ marginBottom: '0px' }}>
          <Navbar.Header>
            <Navbar.Brand>
              <Navbar.Link href="http://www.financialcanvas.co.uk/" style={{ color: 'white' }}>
                Financial Canvas Studio
              </Navbar.Link>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Navbar.Text>
              <Navbar.Link onClick={this.open} style={{ cursor: 'pointer' }}>Get in touch</Navbar.Link>
            </Navbar.Text>
            <Nav pullRight>
              <NavDropdown title={this.props.dashboard} id="dashboard-nav-dropdown">
                {this.props.options.map(option => (<LinkContainer to={`/dashboard/${option.value}`} key={option.value}><MenuItem >{option.label}</MenuItem></LinkContainer>))}
              </NavDropdown>
              <NavDropdown noCaret title={<Glyphicon glyph="info-sign" />} id="info-nav-dropdown">
                <MenuItem header>Data source</MenuItem>
                <MenuItem><Glyphicon glyph="time" />  Last updated {this.props.lastUpdated !== undefined ? <Moment fromNow date={moment.utc(this.props.lastUpdated)} /> : 'Unknown'}</MenuItem>
                <MenuItem><Glyphicon glyph="user" />  By {this.props.updatedBy}</MenuItem>
                <MenuItem divider />
                <MenuItem header>About</MenuItem>
                <MenuItem>Version {this.props.version}</MenuItem>
              </NavDropdown>
              {this.props.enableAuth ? (
                <NavDropdown noCaret title={<Glyphicon glyph="user" />} id="account-nav-dropdown">
                  <MenuItem header>Account</MenuItem>
                  <MenuItem><Glyphicon glyph="user" />  {this.props.user}</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={this.props.onLogOut}>Sign out</MenuItem>
                </NavDropdown>
              ) : null}
            </Nav>
          </Navbar.Collapse>
        </Navbar >
        {this.props.enableAuth ? privateFeedback : publicFeedback}
      </div>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js